import React from 'react';

import { useMembership } from './useMembership';

const withMembershipPrice = WrappedComponent => {
  const ComponentWithMembershipPrice = props => {
    const { price: membershipPrice } = useMembership();

    return <WrappedComponent {...props} membershipPrice={membershipPrice} />;
  };

  ComponentWithMembershipPrice.displayName = `withMembershipPrice(${
    WrappedComponent.displayName || WrappedComponent.name || 'Component'
  })`;

  return ComponentWithMembershipPrice;
};

export default withMembershipPrice;
